import React, { useEffect, useState } from 'react';
import { Constants } from '../../util/Constants';
import {
  assemble,
  correctInternalLink,
  createFilterDataPartners,
  getAlgoliaDatasetValue,
  getAlgoliaIndex,
  isItUndefined, isLinkAbsolute,
  marketoOptions as options,
} from '../../util/DataUtil';
import ResourceFilter from '../resources/resource-filter';
import { useWindowSize } from '../../util/PageUtil';
import Loading from '../layout/Loading';
import Link from "next/link";

const PartnersCardsBlock = ({ lang, global, categories, data }) => {
  const [algoliaData, setAlgoliaData] = useState([]);
  const [facetFilters, setFacetFilters] = useState([]);
  const algoliaDataset = getAlgoliaDatasetValue('4') + getAlgoliaIndex();
  const [hitsPerPage, setHitsPerPage] = useState(8);
  const [query, setQuery] = useState([]);
  const [page, setPage] = useState(0);
  const [showMore, setShowMore] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterProps, setFilterProps] = useState([]);
  const [languageFilter, setLanguageFilter] = useState([]);
  const [applyFilter, setApplyFilter] = useState(false);
  const [filter, setFilter] = useState(0);
  const [anchorToTop, setAnchorToTop] = useState(0);

  let facetFiltersArray = [];
  let categoryName = [];
  let lngArray = [];

  const windowSize = useWindowSize();
  const linkText = data.field_internal_link_text?.[0]?.value?.trim() || "Learn More";

  useEffect(() => {
    fetchAlgoliaData();
  }, [hitsPerPage]);

  useEffect(() => {
    if (!lang) {
      return;
    }
    fetchAlgoliaData();
  }, [applyFilter, query, filter]);

  useEffect(() => {
    console.log('algolia data', algoliaData);
  }, [algoliaData]);

  useEffect(() => {
    if (anchorToTop > 0) {
      let doc = document.getElementById('partners-cards-container');
      window.scrollTo({ top: doc?.offsetTop - 80, behavior: 'smooth' });
    }
  }, [anchorToTop]);

  const fetchAlgoliaData = () => {
    if (!algoliaData?.hits?.length) {
      setIsLoading(true);
    }
    let url = createFilterDataPartners(
      lngArray,
      facetFiltersArray,
      facetFilters,
      query,
      hitsPerPage,
      page,
      lang,
      algoliaDataset,
      categoryName
    );

    const fetchAlgolia = async () => {
      await fetch(url, options)
        .then((response) => response.json())
        .then((newResponse) => {
          setShowMore(newResponse.hits);
          setAlgoliaData(newResponse);
        })
        .finally(() => {
          if (!algoliaData?.hits?.length) {
            setIsLoading(false);
          }
        });
    };
    fetchAlgolia();
  };

  const loadMore = () => {
    setHitsPerPage(hitsPerPage + 9);
  };

  const handleShowLess = () => {
    if (hitsPerPage > 8) {
      setHitsPerPage(8);
      setAnchorToTop(anchorToTop + 1);
    }
  };

  const clearQuery = () => {
    setQuery([]);
    setIsSearchActive(false);
    setIsFilterActive(true);
  };

  const clearAll = () => {
    setFilterProps([]);
    triggerFilter([]);
    setLanguageFilter([]);
    // setQuery([]);
    if (query.length > 0) {
      setQuery([]);
    }
    setShowMore([]);
    setFilter(!filter);
    setPage(0);
    setHitsPerPage(8);
    setIsFilterActive(false);
  };

  const triggerFilter = (filters) => {
    setFilterProps(filters);

    let searchFilters = [];
    for (let filter of filters) {
      // searchFilters.push(filter.field_source_translation);
      searchFilters.push(filter);
    }

    setFacetFilters(searchFilters);
    setPage(0);
    setHitsPerPage(8);
    setApplyFilter(!applyFilter);
  };

  const handleSearch = (search) => {
    setQuery(search.length !== 0 ? [search] : []);
    // setFilterProps([]);
    // setFacetFilters([]);
    setPage(0);
    setApplyFilter(!applyFilter);
  };

  const handleClick = (url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      console.warn('URL is undefined or invalid');
    }
  };

  return (
    <div id="partners-cards-container" className="partners-cards-main">
      <ResourceFilter
        singleFilter={true}
        clearQuery={clearQuery}
        isSearchActive={isSearchActive}
        isFilterActive={isFilterActive}
        setIsSearchActive={setIsSearchActive}
        setIsFilterActive={setIsFilterActive}
        search={isItUndefined(global.field_search_text_translation)}
        // title={isItUndefined(data.field_filter_resources)}
        filterProps={filterProps}
        triggerFilter={triggerFilter}
        data={assemble(categories)}
        onSearchChange={handleSearch}
        handleFilterApply={setApplyFilter}
        searchQuery={query}
        setQuery={setQuery}
        languageFilter={languageFilter}
        setLanguageFilter={setLanguageFilter}
        screenWidth={windowSize.width}
        clearAll={clearAll}
        title={isItUndefined(global.field_filter_text)}
        setFilter={setFilter}
        filter={filter}
        cancelText={isItUndefined(global.field_cancel_text_translation)}
        applyFilterText={isItUndefined(global.field_apply_filters_text)}
        clearAllText={isItUndefined(global.field_clear_all_text)}
        selectedText={isItUndefined(global.field_selected_text)}
        seeMoreText={isItUndefined(global?.field_see_more_text)}
        seeLessText={isItUndefined(global?.field_see_less)}
        isPartnerPage={true}
      />
      {!isLoading ? (
        algoliaData.nbHits != 0 ? (
          <>
            <div className="partners-cards-container">
              {algoliaData.hits
                ?.sort((a, b) => {
                  // Ensure featured partners stay on top
                  if (a?.field_featured_partner && !b?.field_featured_partner)
                    return -1;
                  if (!a?.field_featured_partner && b?.field_featured_partner)
                    return 1;

                  // Sort alphabetically if both are featured or both are not
                  return a?.field_partner_name?.localeCompare(
                    b?.field_partner_name
                  );
                })
                .map((partner, index) => (
                  <div
                    key={index}
                    className={`partner-card ${partner?.field_featured_partner ? 'featured-partner' : ''}`}
                    onClick={() => partner?.field_partner_internal_url ? handleClick(partner?.field_partner_internal_url) : handleClick(partner?.field_partner_url)}
                  >
                    {partner?.field_featured_partner && (
                      <span className="badge">Featured partner</span>
                    )}
                    {partner?.field_partner_url && !partner?.field_partner_internal_url ?  (
                    <svg
                      className="external-link-icon"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_31833_35843)">
                        <path
                          d="M21 0C20.45 0 20 0.45 20 1C20 1.55 20.45 2 21 2H28.5875L13.2937 17.2938C12.9062 17.6813 12.9062 18.3187 13.2937 18.7062C13.6812 19.0938 14.3188 19.0938 14.7063 18.7062L30 3.4125V11C30 11.55 30.45 12 31 12C31.55 12 32 11.55 32 11V1C32 0.45 31.55 0 31 0H21ZM4 2C1.79375 2 0 3.79375 0 6V28C0 30.2062 1.79375 32 4 32H26C28.2062 32 30 30.2062 30 28V19C30 18.45 29.55 18 29 18C28.45 18 28 18.45 28 19V28C28 29.1063 27.1063 30 26 30H4C2.89375 30 2 29.1063 2 28V6C2 4.89375 2.89375 4 4 4H13C13.55 4 14 3.55 14 3C14 2.45 13.55 2 13 2H4Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_31833_35843">
                          <rect width="32" height="32" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>) : null}
                    <img
                      src={partner?.url}
                      alt={partner?.field_partner_name}
                      className="partner-logo"
                    />

                    <p className="partner-name">
                      {partner?.field_partner_name}
                    </p>
                    <p className="partner-description">
                      {partner?.field_partner_short_description}
                    </p>


                    {partner?.field_partner_internal_url ? (
                    <Link
                        href={correctInternalLink(partner?.field_partner_internal_url)}
                        passHref
                        legacyBehavior
                    >
                      <a
                          target={isLinkAbsolute(partner?.field_partner_internal_url) ? '_blank' : '_self'}
                          // className="link-internal"
                          className="cta>-link"
                          onClick={(event) => event.stopPropagation()} // Prevent parent click event
                      >
                        {linkText}
                        <img
                            alt="arrow"
                            className="more-arrow"
                            src="/images/learn-more-arrow.svg"
                        />
                      </a>
                    </Link> ) : null}

                  </div>
                ))}
            </div>
            <div className="load-more-container">
              {algoliaData.page + 1 !== algoliaData.nbPages &&
              algoliaData.nbHits !== 0 &&
              algoliaData.nbHits > 8 ? (
                <button onClick={loadMore} className="load-more-btn">
                  {isItUndefined(global?.field_load_more_text)}
                </button>
              ) : algoliaData.nbHits > 8 ? (
                <button onClick={handleShowLess} className="see-less-btn">
                  {isItUndefined(global?.field_show_less_text)}
                </button>
              ) : null}
            </div>
          </>
        ) : (
          <div className={'no-results-wrapper'}>
            <div className={'inner-container'}>
              <div className={'no-results'}>
                {isItUndefined(global.field_no_result_text)
                  ? isItUndefined(global.field_no_result_text)
                  : 'No results were found. Please check the spelling, reset any filters and try again.'}
              </div>
            </div>
          </div>
        )
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default PartnersCardsBlock;
